// import React from 'react'

// const index = () => {
//   return (
//     <div>index</div>
//   )
// }

// export default index

import React, { useState, useEffect } from "react";
// import "./CheckWarranty.scss";
import { useNavigate } from "react-router-dom";
// import axiosInstance from "../../../services/api/API";
import axiosInstance from "../../../../services/api/API";
// import CustomTable from "../../../customComponents/CustomTable";
import CustomTable from "../../../../customComponents/CustomTable";
// import ROUTES_NAVIGATION from "../../../../routes/routes";
import viewIcon from "../../../../../Assets/icons/ClaimIcon.svg";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
import DownloadSVG from "../../../../../Assets/icons/DownloadIconMIS.svg";
import download from "../../../../../Assets/icons/download.svg";
import * as base64 from "base-64";
import { showErrorAlert } from "../../../../customComponents/CustomSweetAlert/errorsweetalert";
import { FiDownload } from "react-icons/fi";
// download
// import DetailsTable from "../../Admin/OrderManagement/CustomOrderTable/CustomOrderTable";

const MisReportClaim = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [variantOptions, setVariantOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [filterList, setFilterList] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [filters, setFilters] = useState({});
  const [vinNoData, setVinNoData] = useState([]);
  // const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [dealerOption, setDealerOptions] = useState([]);

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const dealerId = localStorage.getItem("dealerId");
  localStorage.removeItem("JobCardComplainData");

  useEffect(() => {
    fetchJobCardList();
  }, [filterList]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchJobCardList(newPage);
  };

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    // Format to YYYY-MM-DD without timezone influence
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  };

  const fetchJobCardList = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;
    const payload = {
      orderBy: "postockinsr_id desc",
      page,
      pageSize,
      fromDate: formatDate(allfilteredData?.fromDate),
      toDate: formatDate(allfilteredData?.toDate),
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
      // toDate: allfilteredData?.toDate ? allfilteredData?.toDate : null,
      dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : null,
      vinNum: null,
    };
    try {
      // setTableLoader(true)
      const response = await axiosInstance.post(
        "/mis/warranty-claim-report",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // setTableLoader(false)
      const formattedData = response?.data?.data?.data.map((item, index) => ({
        ...item,
        item_name: item.item_name || "--",
        model_name: item.model_name || "--",
        variant_name: item.variant_name || "--",
      }));
      const totalRecordsData = response?.data?.data?.totalRecords;
      setTotalRecords(totalRecordsData);

      setVinNoData(formattedData);

      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching business partners:", error);
      // setIsSearchPerformed(false);
    }
  };

  const onClickNavigetion = (item) => {
    return (
      <div onClick={() => handleEdit(item)}>
        <span style={{ color: "green" }}> {item?.job_card_no}</span>
      </div>
    );
  };

  const handleEdit = (rowData) => {
    navigate("add-job-card", {
      state: { jobCardDataDetails: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const handleViewButton = (rowData) => {
    navigate("job-card-details", {
      state: { data: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  // Table headers
  const Job_Card_TABLE_HEADERS = [
    "Dealer Name",
    "Claim Code",
    "Vin Number",
    "Job Card Number",
    "Jobcard Done Date",
    "Service Type",
    "Dealer Trade Date",
    "Engineer Name",
    // "INVOICE COPY",
    // "Total Accessories",
    // "Action"
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    "Dealer Name": "dealer_name",
    "Vin Number": "vin_no",
    "Job Card Number": "job_card_no",
    "Jobcard Done Date": "jobcard_done_date",
    "Service Type": "service_type",
    "Claim Code": "claimCode",
    "INVOICE COPY": "total_sparepart",
    "Dealer Trade Date": "trade_date",
    "Engineer Name": "engineer_name",
    // "Total Accessories": "total_accessories",
    // "Vin No.":"dealer_name",
    // "Days":"remaining_days",
    //  "Warranty From":"warrantyFrom",
    // "Warranty To":"warrantyTo",
    Action: [
      {
        type: "print",
        icon: download,
        label: "Print",
      },
    ],
  };

  const onclickFilter = (row) => {
    setFilterList(row);
  };

  useEffect(() => {
    fetchJobCardList();
  }, [filters]);

  // const clearFilter = () => {
  //   setFilterFormData({});
  //   setFilters({});
  //   fetchJobCardList();
  // };
  useEffect(() => {
    if (searchTerm === "") {
      fetchJobCardList();
    }
  }, [searchTerm]);

  // const handleSearch = () => {
  //   setFilters({
  //     vinNumber: filterFormData.searchTerm || null
  //   });
  //   // setIsSearchPerformed(true);
  //   fetchJobCardList();
  // };
  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleClear = () => {
    setFilterFormData({});
  };
  const handleClaim = () => {
    console.log("clicked");
    // navigate(ROUTES_NAVIGATION.ADDJOBCARD)
  };

  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post("/dealer/ddldealer", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async () => {
    try {
      const payload = {
        orderBy: "model_id desc",
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post("/model/ddlmodel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));
      console.log(options, "responseVal");

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    // const colorId = formData.color
    const modelId = filterFormData.modelId;

    if (modelId) {
      fetchVariantOptions(modelId);
    }
  }, [filterFormData.modelId]);

  const fetchVariantOptions = async (modelId) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {
          // color_id: colorId,
          model_id: modelId,
          // dealer_id:dealer_id
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  const PhysicalStockTakingInputs = [
    {
      name: "dealerId",
      label: "Dealer ",
      placeholder: "Select Dealer",
      type: "dropdown",
      options: dealerOption,
      // required: true,
      gridClass: "col-lg-3",
    },
    {
      name: "fromDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-lg-3",
    },
    {
      name: "toDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-lg-3",
    },
  ];

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      // is_order_accepted:filterFormData.is_order_accepted || 0,
      fromDate: filterFormData.fromDate || null,
      toDate: filterFormData.toDate || null,
      dealerId: filterFormData.dealerId || null,
    });
  };
  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchJobCardList();
  };

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      // dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : dealerId,

      orderBy: "postockinsr_id desc",
      page: 0,
      pageSize: 10,
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
      // toDate: allfilteredData?.toDate ? allfilteredData?.toDate : null,
      fromDate: formatDate(allfilteredData?.fromDate),
      toDate: formatDate(allfilteredData?.toDate),
      dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : null,
      vinNum: null,
    };

    try {
      const response = await axiosInstance.post(
        "/mis/warranty-claim-report-excel",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob", // Important: Ensures the response is treated as a file
        }
      );

      // Create a Blob from the response
      const blob = new Blob([response.data], { type: "text/csv" });

      // Create a download link
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Warranty Claim Report.csv"; // Set the file name
      link.style.display = "none";

      // Append the link to the body and trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up the link element
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);

      const errorMessage = error?.response?.statusText;
      console.log(errorMessage, "errorMessage");

      const alertText =
        errorMessage === "Not Found"
          ? "Record not found"
          : errorMessage || "Something went wrong";

      showErrorAlert({
        title: "Warning",
        text: alertText,
        callback: () => {
          console.log("Error alert confirmed");
        },
      });
    }
  };

  const DownLoadPdf = (row) => {
    var text = row?.job_card_id;
    var encoded = base64.encode(text);
    const pdfURL = `${process.env.REACT_APP_API_BASE_URL}jobcardpdfreport/jobCardInvoiceDownload/${encoded}`;
    window.open(pdfURL, "_blank", "noopener,noreferrer");
  };

  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div
          style={{ width: "100%" }}
          className="OnboardManagamentbuttonContainer  col-md-3 mt-2 mb-2"
        >
          <div
            style={{
              lineHeight: "1px",
              display: "flex",
              flexDirection: "column",
              paddingTop: "30px",
            }}
          >
            <div>
              <p className="ServiceBreadcrumbs">Home / Report / MIS Report </p>
            </div>
            <div>
              <h5
                style={{ fontWeight: "600" }}
                className="checkWarrantyHeading"
              >
                Warranty Claim Report
              </h5>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "25px",
            }}
          >
            <ListLogisticsFilters
              formConfig={PhysicalStockTakingInputs}
              formData={filterFormData}
              setFormData={setFilterFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              handleSearch={handleSearch}
              handleClear={clearFilter}
            />
            {/* <img
              onClick={downloadExcel}
              src={DownloadSVG}
              alt="downloadSvg"
              style={{ paddingTop: "33px", cursor: "pointer" }}
            /> */}
            <div
              onClick={downloadExcel}
              className="flte-btnnn"
              style={{
                borderRadius: "38px",
                cursor: "pointer",
                fontSize: "15px",
                marginTop: "2rem",
              }}
            >
              Warranty Claim Report Download
              <span>
                <FiDownload
                  className="downloadexcel-misreportsales"
                  style={{ cursor: "pointer" }}
                  size={22}
                />
              </span>
            </div>
            <div></div>
          </div>
        </div>
        <div className=" col-md-8 mt-2 mb-2 gap-2 totalvaluescontainer">
          <div className="listSideBorder" />
        </div>
      </div>
      <div className="tableWrapper">
        <div className="filterView"></div>

        <div style={{ paddingTop: "20px" }}>
          <CustomTable
            data={vinNoData}
            headers={Job_Card_TABLE_HEADERS}
            keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
            onEdit={handleEdit}
            handleViewButton={handleViewButton}
            itemsPerPage={10}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            totalRecords={totalRecords}
            handleClaim={handleClaim}
            // isADDcomplainTable="true"
            pdfDownLoad={DownLoadPdf}
            currentPage={currentPage}
          />
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default MisReportClaim;
